import { useLocation, Navigate } from 'react-router-dom';
import useAccess from '../../TRC/hooks/useAccess';
import { getTRCRedirectPath } from './utils/trcRouteHelper';
import LoadingPage from '@/component/loading';

const ProtectedTRC = ({ children }) => {
	const { hasAccess, loading, initialLoad, accessStatus } = useAccess();
	const location = useLocation();

	const cachedStatus = accessStatus || localStorage.getItem('userAccessStatus')?.replace(/"/g, '');
	const effectiveHasAccess = hasAccess || cachedStatus === 'approved';

	if ((loading || initialLoad) && !cachedStatus) {
		return <LoadingPage />;
	}

	const redirectPath = getTRCRedirectPath({ hasAccess: effectiveHasAccess, currentPath: location.pathname });
	if (redirectPath) {
		return <Navigate to={redirectPath} replace />;
	}

	return <>{children}</>;
};

export default ProtectedTRC;
